import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-comparison-card',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './comparison-card.component.html',
  styleUrl: './comparison-card.component.scss'
})
export class ComparisonCardComponent {

  @Input()
  color: any = {};

  @Input()
  data: any = {
    id: 'TC_SBDSN',
    steps: [
      'ishajkasd',
      'asdjkbjasdsadasd',
      'sakdjbjkasdas',
      'askdjbkjasdjkkjvasdh'
    ],
    results: [
      'ishajkasd',
      'asdjkbjasdsadasd',
      'sakdjbjkasdas',
      'askdjbkjasdjkkjvasdh'
    ]
  };



}
